'use client';

import { useEffect, useRef } from 'react';
import { getTranslationFor } from '@/text/translations';
import ApplicationButton from '@/components/ApplicationButton/ApplicationButton';
import styles from './HomeHero.module.css';

export default function HomeHero() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const ensurePlay = () => {
      if (video.paused) {
        video.play().catch(() => {});
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        ensurePlay();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', ensurePlay);

    ensurePlay();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', ensurePlay);
    };
  }, []);

  return (
    <div className={styles.container}>
      <video
        ref={videoRef}
        className={styles.backgroundVideo}
        autoPlay
        muted
        loop
        playsInline
        disablePictureInPicture
        controlsList="nodownload nofullscreen noremoteplayback"
        poster="/videos/home-bg-poster.jpg"
      >
        <source src="/videos/home-bg.webm" type="video/webm" />
        <source src="/videos/home-bg.mp4" type="video/mp4" />
      </video>
      <div className={styles.content}>
        <div className={styles.card}>
          <h1 className={styles.title}>{getTranslationFor('home.hero.title')}</h1>
          <p className={styles.paragraph}>{getTranslationFor('home.hero.paragraph1')}</p>
          <p className={styles.paragraph}>{getTranslationFor('home.hero.paragraph2')}</p>
          <ApplicationButton className={styles.button}>
            {getTranslationFor('home.hero.button')}
          </ApplicationButton>
        </div>
      </div>
    </div>
  );
}
